import { Link } from 'react-router-dom';
export default function Logo() {
  return (
    <div className="site-logo">
      <Link to="/">
        <img src="/assets/img/logo-70.svg" alt="TCAS70 Logo" className="logo" width="212" height="96" />
      </Link>
    </div>
  );
}
